import { render } from "./hackathon-footer.vue?vue&type=template&id=51673b11&scoped=true"
import script from "./hackathon-footer.vue?vue&type=script&lang=js"
export * from "./hackathon-footer.vue?vue&type=script&lang=js"

import "./hackathon-footer.vue?vue&type=style&index=0&id=51673b11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51673b11"]])

export default __exports__